// eslint-disable-next-line import/prefer-default-export
export const GetStrategicRelationshipsSelector = ({
  strategicRelationships: { GetStrategicRelationships }
}) => GetStrategicRelationships;

export const PostStrategicRelationshipsSelector = ({
  strategicRelationships: { PostStrategicRelationships }
}) => PostStrategicRelationships;
